/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { withNavList } from 'react-skeletal-nav';
import cx from 'classnames';
import PropTypes from 'prop-types';

import './NavList.scss';

const NavList = ({ children, title, route }) => (
  <div
    className={cx('nav-list', {
      'nav-list--root': route === 'root',
      'nav-list--child': route !== 'root'
    })}>
    {title && <div className="nav-list__title">{title}</div>}
    <ul className="nav-list__list">{children}</ul>
  </div>
);

NavList.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  route: PropTypes.string.isRequired
};

export default withNavList(NavList);
